import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import YearMonthPicker from '../componentes_generales/componentes_formulario/datepicker/yearmonthpicker';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { visualizarReporteEnPdf } from '../../funciones_globales/interaccionApiReportes';
import { formatearFechaMoment_a_StringFormatoReporte, formatearFechaMoment_a_String } from '../../funciones_globales/format';
import { validarFechaMomentEnFormatoString } from '../../funciones_globales/utils';
import { getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { cargarCatalogosGenericoAsync } from '../../funciones_globales/catalogos';

const NRO_ULTIMAS_SEMANAS = 12;

class FormVen23  extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            tipoReporte: 'CV',
            tipoPeriodo: 'S', // P: Periodo personalizado - S: Ultimas semanas
            fechaDesde: null,
            fechaHasta: null,
            mes_sel: null            
        };

        this.gridDetResumenVtasOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: true,
            suppressRowClickSelection: true
          };

        this.limpiar = this.limpiar.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.imprimirResumenVentas = this.imprimirResumenVentas.bind(this);
        this.onGridDetResumenVtasReady = this.onGridDetResumenVtasReady.bind(this);        
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0423');
        let fechaProceso = getFechaProcesoPorModulo('04');  
        let fechaInicio=    moment(fechaProceso,'DD/MM/YYYY'); //WILLY 2020-01-10
        let month= fechaInicio.format('MM');//WILLY 2020-01-10
        let year = fechaInicio.format('YYYY');//WILLY 2020-01-10
        let object="";//WILLY 2020-01-10
        if(month!== null && month!== undefined && year !== null && year !== undefined){//WILLY 2020-01-10
            object = {month:month.toString(), year:year.toString()}
        }
        
        console.log(object)
        if(object!==""){//WILLY 2020-01-10 CAMBIO ERROR AL SELECCIONAR ENERO.
            this.setState({
                fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaActual: moment(fechaProceso, 'DD/MM/YYYY'),
                mes_sel:object
            });
        }else{
            this.setState({
                fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
                fechaActual: moment(fechaProceso, 'DD/MM/YYYY'),
            });
        }
       
       
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0423');
    }

    onGridDetResumenVtasReady(params){
        this.gridApiDetResumenVtas = params.api;
        this.columnApiDetResumenVtas = params.columnApi;
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getOptions_Clientes(input, callback){        
        if (input.toString().length >= 2 ){
            let query = "?cadena_busq=" + input;     
            cargarCatalogosGenericoAsync('/clientes', query, callback)
        }
    }

    getOptions_Vendedores(input, callback){
        if (input.toString().length >= 2 ){
            let cadena_busq = '?cadena_busq=' + input;
            cargarCatalogosGenericoAsync('/vendedores', cadena_busq, callback)              
        }
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('04');        

        this.setState({
            fechaHasta: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaDesde: moment(fechaProceso, 'DD/MM/YYYY'),
            fechaActual: moment(fechaProceso, 'DD/MM/YYYY'),
            tipoReporte: 'CV',
            tipoPeriodo: 'S',
            mes_sel: null
        });
    }

    imprimirResumenVentas(){
        try{

            let urlReportWithParams='';

            if(this.state.tipoPeriodo === 'P'){
                let fechaDesde = formatearFechaMoment_a_String(this.state.fechaDesde);
                if (!validarFechaMomentEnFormatoString(fechaDesde)){
                    alert('La fecha Desde es inválida.');
                    return;
                }
                
                let fechaHasta = formatearFechaMoment_a_String(this.state.fechaHasta);
                if (!validarFechaMomentEnFormatoString(fechaHasta)){
                    alert('La fecha Hasta es inválida.');
                    return;
                }

                if(this.state.fechaHasta.diff(this.state.fechaDesde, 'days')<0){        
                    alert(`La fecha Desde debe ser menor a: ${formatearFechaMoment_a_String(this.state.fechaHasta)}`);
                    return;
                }

                if(this.state.tipoReporte==='CV'){ // Consolidado por vendedor (periodo personalizado)
                    urlReportWithParams=`&rpt=101`;
                }else{
                    urlReportWithParams=`&rpt=102`; // // Consolidado por vendedor y provincia (periodo personalizado)
                }

                urlReportWithParams+=`&param1=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaDesde)}`;
                urlReportWithParams+=`&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaHasta)}`;

            }else{            

                if(this.state.tipoPeriodo==='S'){ 
                    if(this.state.tipoReporte==='CV'){ // Consolidado por vendedor ( desglose semanal a partir de fecha especifica hacia atrás)
                        urlReportWithParams=`&rpt=103`;
                    }else{
                        urlReportWithParams=`&rpt=104`; // Consolidado por vendedor y provincia ( desglose semanal a partir de fecha especifica hacia atrás)
                    }

                    urlReportWithParams+=`&param1=${NRO_ULTIMAS_SEMANAS}&param2=${formatearFechaMoment_a_StringFormatoReporte(this.state.fechaActual)}`;
                }else{
                    if(this.state.tipoReporte==='CV'){ // Consolidado por vendedor ( desglose mensual)
                        urlReportWithParams=`&rpt=105`;
                    }else{
                        urlReportWithParams=`&rpt=106`; // Consolidado por vendedor y provincia ( desglose mensual)
                    }
                    console.log("STATE")
                    console.log(this.state)
                    let mes = this.state.mes_sel.month;
                    let periodo = this.state.mes_sel.year;
                    urlReportWithParams+=`&param1=${mes}&param2=${periodo}`;
                }
            }

            visualizarReporteEnPdf(urlReportWithParams);
            
        }catch(error){
            alert(`Ocurrió un error al generar el reporte. Error: ${error}`);
        }
    } 

    render(){
        return (
            <ContenedorForm porc_ancho={60}>
                <HeaderForm>
                    <TituloForm>Consolidado de Ventas</TituloForm>
                </HeaderForm>
                <CuerpoForm>
                    <Row margen_arriba={15}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Reporte:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>					
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoReporte' value='CV' checked={this.state.tipoReporte==='CV'} onChange={this.handleInputChange} />
                                CONSOLIDADO POR VENDEDOR
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoReporte' value='CVP' checked={this.state.tipoReporte==='CVP'} onChange={this.handleInputChange} />
                                CONSOLIDADO POR VENDEDOR Y PROVINCIA
                            </LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={25}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Tipo Periodo:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-10'>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='S' checked={this.state.tipoPeriodo==='S'} onChange={this.handleInputChange} />
                                ÚLT. {NRO_ULTIMAS_SEMANAS} SEMANAS
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='M' checked={this.state.tipoPeriodo==='M'} onChange={this.handleInputChange} />
                                MENSUAL
                            </LabelForm>
                            <LabelForm className='radio-inline'>
                                <input type='radio' name='tipoPeriodo' value='P' checked={this.state.tipoPeriodo==='P'} onChange={this.handleInputChange} />
                                DESDE - HASTA
                            </LabelForm>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={25} isInvisible={this.state.tipoPeriodo!=='P'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Desde:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaDesde} func_onChange={(fecha)=>{this.setState({fechaDesde: fecha});}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Hasta:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaHasta} func_onChange={(fecha)=>{this.setState({fechaHasta: fecha});}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={25} isInvisible={this.state.tipoPeriodo!=='S'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>F. Actual:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-2'>
                            <PickerFecha fechaSeleccionada={this.state.fechaActual} func_onChange={(fecha)=>{this.setState({fechaActual: fecha});}}/>
                        </ContainerCol>
                    </Row>

                    <Row margen_arriba={25} isInvisible={this.state.tipoPeriodo!=='M'}>
                        <ContainerCol className='col-sm-2'>
                            <LabelForm>Mes:</LabelForm>
                        </ContainerCol>
                        <ContainerCol className='col-sm-3'>
                            <YearMonthPicker name="mes_sel" onChangeData={(mesSel) => this.setState({mes_sel: mesSel})} data={this.state.mes_sel}/>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={25}>
                        <ContainerCol className='col-sm-12'>
                            <div className='btn-group pull-right'>
                                <button type='button' className='btn btn-info btn-sm' onClick={this.imprimirResumenVentas}><i className='fa fa-print fa-lg' aria-hidden='true'/> Imprimir</button>
                                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg' aria-hidden='true'></i> Limpiar</button>
                            </div>
                        </ContainerCol>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapDispatchToProps = ((dispatch) => {  
    return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm}, dispatch)
});

export default connect (null, mapDispatchToProps)(FormVen23);